export const CONNECTIONS = [
  {
    id:1, title:"World Cup Hosts",
    groups:[
      { label:"Hosted the World Cup in the 1930s", colour:"#16a34a", items:["Uruguay","Italy","France","Brazil"] },
      { label:"Hosted the World Cup in the 1960s–70s", colour:"#ca8a04", items:["Chile","England","Mexico","West Germany"] },
      { label:"First-time hosts outside Europe & Americas", colour:"#ea580c", items:["South Korea","South Africa","Qatar","Japan"] },
      { label:"Countries that hosted the World Cup twice", colour:"#dc2626", items:["Mexico","Italy","France","Germany"] },
    ]
  },
  {
    id:2, title:"1986 World Cup — Hand of God Match",
    groups:[
      { label:"Players on the pitch for Argentina", colour:"#16a34a", items:["Maradona","Valdano","Burruchaga","Enrique"] },
      { label:"England players in that quarter-final", colour:"#ca8a04", items:["Peter Shilton","Steve Hodge","Peter Beardsley","Gary Lineker"] },
      { label:"Maradona dribbled past on the Goal of the Century", colour:"#ea580c", items:["Terry Butcher","Terry Fenwick","Peter Shilton","Kenny Sansom"] },
      { label:"Scored at the 1986 World Cup", colour:"#dc2626", items:["Gary Lineker","Emilio Butragueno","Preben Elkjaer","Diego Maradona"] },
    ]
  },
  {
    id:3, title:"World Cup Golden Boots",
    groups:[
      { label:"Won the Golden Boot in the 1980s–90s", colour:"#16a34a", items:["Gary Lineker","Salvatore Schillaci","Hristo Stoichkov","Davor Suker"] },
      { label:"Won the Golden Boot in the 2000s", colour:"#ca8a04", items:["Ronaldo R9","Miroslav Klose","Thomas Muller","David Villa"] },
      { label:"Won the Golden Boot in the 2010s–20s", colour:"#ea580c", items:["Thomas Muller","James Rodriguez","Harry Kane","Kylian Mbappe"] },
      { label:"All-time top 4 scorers at World Cups", colour:"#dc2626", items:["Miroslav Klose","Ronaldo R9","Gerd Muller","Just Fontaine"] },
    ]
  },
  {
    id:4, title:"Penalty Drama",
    groups:[
      { label:"Missed famous World Cup penalties", colour:"#16a34a", items:["Roberto Baggio","Stuart Pearce","Chris Waddle","Gareth Southgate"] },
      { label:"Scored a World Cup Final penalty", colour:"#ca8a04", items:["Zinedine Zidane","Kylian Mbappe","Gonzalo Montiel","Andrea Pirlo"] },
      { label:"Won their World Cup on penalties", colour:"#ea580c", items:["Brazil 1994","Italy 2006","Argentina 2022","France 2006"] },
      { label:"Legendary World Cup goalkeepers", colour:"#dc2626", items:["Peter Shilton","Gianluigi Buffon","Iker Casillas","Sepp Maier"] },
    ]
  },
  {
    id:5, title:"World Cup Nations",
    groups:[
      { label:"Have won the World Cup 3+ times", colour:"#16a34a", items:["Brazil","Germany","Italy","Argentina"] },
      { label:"Lost the World Cup Final but never won it", colour:"#ca8a04", items:["Netherlands","Hungary","Czechoslovakia","Sweden"] },
      { label:"Reached the semi-finals but never the final", colour:"#ea580c", items:["Poland","Turkey","Morocco","Chile"] },
      { label:"Biggest World Cup upsets — the team beaten", colour:"#dc2626", items:["France (2002)","Germany (2018)","Spain (2014)","Italy (2010)"] },
    ]
  },
  {
    id:6, title:"Rovers & Forest World Cup Connections",
    groups:[
      { label:"Blackburn Rovers players at the 2002 World Cup", colour:"#16a34a", items:["Brad Friedel","Damien Duff","Tugay","Roque Santa Cruz"] },
      { label:"Nottingham Forest players at Italia 90", colour:"#ca8a04", items:["Peter Shilton","Stuart Pearce","Des Walker","Steve Hodge"] },
      { label:"Won the World Cup then signed for Nottingham Forest", colour:"#ea580c", items:["Gonzalo Montiel","Danilo","Murillo","Nuno Tavares"] },
      { label:"Managed England at World Cup AND later managed in the Championship", colour:"#dc2626", items:["Sven-Goran Eriksson","Peter Taylor","Glenn Hoddle","Steve McClaren"] },
    ]
  },
  {
    id:7, title:"2022 World Cup",
    groups:[
      { label:"Scored in the 2022 World Cup Final", colour:"#16a34a", items:["Kylian Mbappe","Angel Di Maria","Alexis Mac Allister","Hugo Lloris"] },
      { label:"2022 World Cup semi-finalists", colour:"#ca8a04", items:["Argentina","France","Morocco","Croatia"] },
      { label:"Retired after the 2022 World Cup", colour:"#ea580c", items:["Luka Modric","Thomas Muller","Karim Benzema","Manuel Neuer"] },
      { label:"2022 World Cup host cities", colour:"#dc2626", items:["Doha","Al Rayyan","Al Wakrah","Al Khor"] },
    ]
  },
  {
    id:8, title:"World Cup Managers",
    groups:[
      { label:"Won the World Cup as manager", colour:"#16a34a", items:["Didier Deschamps","Joachim Low","Vicente del Bosque","Luiz Felipe Scolari"] },
      { label:"Lost the World Cup Final as manager", colour:"#ca8a04", items:["Louis van Gaal","Ottmar Hitzfeld","Luiz Felipe Scolari","Didier Deschamps"] },
      { label:"Managed England at a World Cup", colour:"#ea580c", items:["Bobby Robson","Terry Venables","Sven-Goran Eriksson","Fabio Capello"] },
      { label:"Won the World Cup as player AND manager", colour:"#dc2626", items:["Didier Deschamps","Franz Beckenbauer","Mario Zagallo","Dunga"] },
    ]
  },
];
